import styled from 'styled-components';

const halfDuration = ({ animationDuration }: { animationDuration?: number }) =>
  animationDuration ? `${animationDuration / 2}ms` : '0ms';

export const ExpandableContentWrapper = styled.div<{ animationDuration: number }>`
  position: relative;

  &.details-enter,
  &.details-exit {
    pointer-events: none;
  }

  &.details-enter {
    transition: height ${halfDuration} ease 0ms, opacity ${halfDuration} ease ${halfDuration};
  }

  &.details-exit {
    transition: opacity ${halfDuration} ease 0ms, height ${halfDuration} ease ${halfDuration};
  }
`;

export const ExpandableContentContent = styled.div`
  .details-enter > &,
  .details-exit > & {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`;
